"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _axios = _interopRequireDefault(require("axios"));
var _Detail = _interopRequireDefault(require("./components/Detail"));
var _Progress = _interopRequireDefault(require("@/components/Progress"));
var _index = require("@/utils/index");
var _common = require("@/mixins/common");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    Detail: _Detail.default,
    Progress: _Progress.default
  },
  mixins: [_common.common],
  data: function data() {
    return {
      props: {
        stripe: false,
        border: false,
        showHeader: true,
        showSummary: false,
        showRowHover: true,
        showIndex: false,
        treeType: false,
        isFold: true,
        expandType: true,
        selectionType: false
      },
      form: {
        file: null,
        partnerPk: null,
        partnerName: '',
        partnerCode: '',
        detailAddress: '',
        provinceCode: '',
        cityCode: '',
        districtCode: '',
        region: ''
      },
      initForm: {
        partnerPk: null,
        partnerName: '',
        partnerCode: '',
        detailAddress: '',
        provinceCode: '',
        cityCode: '',
        districtCode: '',
        region: ''
      },
      pageName: 'organizationArchitecture',
      formLabelWidth: '120px',
      loadingComponent: null,
      listLoading: false,
      isLoading: false,
      list: [],
      sourceApi: null,
      searchVal: {
        employeeNumber: '',
        name: ''
      },
      isError: '',
      isShowModel: false,
      isShowProgress: false,
      excelBatchId: '',
      fileImportProcessUniqueCode: '',
      showClose: false,
      showResult: false,
      confirmText: this.$t('common.confirm'),
      activeName: 'GY'
    };
  },
  watch: {
    isLoading: function isLoading(newValue) {
      // pc unlock 锁屏会导致页面晃动
      if (newValue) {
        this.loadingComponent = this.$loading({
          // lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(255, 255, 255, 0)'
        });
      } else {
        if (this.loadingComponent) {
          this.loadingComponent.close();
        }
      }
    },
    '$store.getters.language': function $storeGettersLanguage(newValue) {
      // 监听语言变更重新请求配置查询接口
      this.getLookupTypeCode(['TEAM_TYPE']);
    }
  },
  mounted: function mounted() {
    this.fetchData();
    this.getLookupTypeCode(['TEAM_TYPE']);
  },
  methods: {
    fetchData: function fetchData() {
      var _this = this;
      if (this.sourceApi) {
        this.sourceApi.cancel('cancel');
      }
      this.sourceApi = _axios.default.CancelToken.source();
      var param = {
        type: this.activeName
      };
      this.listLoading = true;
      this.$api.organization.getBizOrgInfoList(param, this.sourceApi.token).then(function (res) {
        _this.listLoading = false;
        _this.list = res.data;
      }).catch(function (err) {
        if (_axios.default.isCancel(err)) {
          return false;
        }
        _this.listLoading = false;
      });
    },
    downloadExcel: function downloadExcel(name) {
      var _this2 = this;
      this.isLoading = true;
      this.$api.organization.export({
        type: this.activeName
      }).then(function (res) {
        _this2.isLoading = false;
        (0, _index.downloadFileExcel)(name, res.data);
      }).catch(function () {
        _this2.isLoading = false;
      });
    },
    uploadData: function uploadData(file, fileList) {
      var _this3 = this;
      // 数据状态初始化
      this.confirmText = this.$t('common.confirm');
      var rawFile = file.raw;
      if (!rawFile) return;
      if (rawFile.size > 100 * 1024 * 1024) {
        this.$message.error('The file size cannot exceed 100M');
        return;
      }
      this.isLoading = true;
      var param = new FormData();
      param.append('file', rawFile);
      this.$api.organization.import(param, this.activeName).then(function (res) {
        _this3.isLoading = false;
        _this3.isShowProgress = true;
        _this3.excelBatchId = res.data.excelBatchId;
        _this3.fileImportProcessUniqueCode = res.data.redisKey;
        _this3.showClose = true;
        _this3.$nextTick(function () {
          _this3.$refs['progress'].start();
        });
      }).catch(function (res) {
        _this3.isLoading = false;
      });
    },
    searchData: function searchData() {
      this.fetchData();
    },
    handleError: function handleError() {
      this.confirmText = this.$t('common.checkResult');
    },
    handleEnd: function handleEnd() {
      this.searchData();
    },
    handleClickConfirm: function handleClickConfirm() {
      if (this.confirmText === this.$t('common.checkResult')) {
        this.isShowProgress = false;
        this.isShowModel = true;
      } else {
        this.isShowProgress = false;
      }
    },
    downloadResultExcel: function downloadResultExcel(name) {
      var _this4 = this;
      this.isLoading = true;
      this.$api.common.downloadResultExcel(this.excelBatchId).then(function (res) {
        _this4.isLoading = false;
        (0, _index.downloadFileExcel)(name, res.data);
      }).catch(function () {
        _this4.isLoading = false;
      });
    },
    handleClick: function handleClick() {
      console.log(this.activeName);
      this.fetchData();
    }
  }
};